export default __webpack_public_path__ + "e58cffb4b8c5d8748b2b235057b31a26.svg";